<div class="language-selector">
  <button
    class="language-button"
    [class.language-button--open]="open()"
    type="button"
    (click)="toggle()"
    [attr.aria-label]="'select_language'"
    [attr.aria-expanded]="open()"
  >
    @if (activeFlag(); as flag) {
    <img class="language-flag" [src]="flag" [alt]="activeLang()" />
    } @else {
    <i class="pi pi-globe language-icon"></i>
    }
  </button>

  <div class="language-panel" [class.language-panel--open]="open()" role="menu">
    <div class="language-menu">
      <p class="language-menu-title">{{ 'select_language' | transloco }}</p>
      <div class="language-menu-items">
        @for (lang of avaiLableLang; track lang.value) {
        <button
          type="button"
          class="language-menu-item"
          [class.active]="activeLang() === lang.value"
          (click)="selectLanguage(lang.value)"
        >
          <span class="language-flag-badge">
            <img [src]="lang.flag" [alt]="lang.value" />
          </span>
          <span class="language-name">{{ lang.label }}</span>
          @if (activeLang() === lang.value) {
          <i class="pi pi-check check-icon"></i>
          }
        </button>
        }
      </div>
    </div>
  </div>
</div>
